<div class="alertMessage" *ngIf="!isMobile()">
  <ion-icon name="alert-circle-outline"></ion-icon>
    {{ isFbOnline() ? ('fb_txt_num1' | translate) : ('fbnoPresencial' | translate) }}
</div>
<div class="empty-state" *ngIf="!isMobile()">
  <img class="m-top-1" src="assets/global/img/freebet-ticket.png" alt="" />
</div>
<empty-state
  class="empty-state-mobile"
  [message]="isFbOnline() ? 'fb_txt_num1': 'fbnoPresencial'"
  [imageSource]="'assets/global/img/freebet-ticket.png'"
  *ngIf="isMobile()"
></empty-state>